import type { PlantConfig } from '../../engine/plant/types';
import { equipment, extraTags, streams } from './equipment';
import { instruments } from './instruments';
import { alarms, interlocks, loops, sequences } from './control';
import { faults, kpis } from './faults';
import { layout } from './layout';
import { scenarios, tuningChallenges } from './scenarios';
import { designPreset } from './preset';
import { lessons } from './lessons';

export const cstrUnit: PlantConfig = {
  id: 'cstr-unit',
  name: 'Northfield Reactor Unit',
  description:
    'An exothermic continuous stirred-tank reactor: ratio-controlled feeds, a preheater, a ' +
    'jacketed 4 m³ reactor on cascade temperature control, and a flash separator. Lose the ' +
    'cooling for long enough and it runs away.',
  species: ['A', 'B', 'S', 'L'],
  density: 900,
  designConditions: {
    feedA: 8,
    feedB: 4,
    feedRatio: 0.5,
    feedTemperature: 310.15,
    reactorTemperature: 350,
    reactorLevel: 80,
    conversion: 95.2,
    jacketFlow: 15.7,
    jacketOutlet: 305.1,
    coolingWaterSupply: 298.15,
    separatorPressure: 2.0,
    separatorLevel: 50,
  },
  equipment,
  streams,
  instruments,
  loops,
  sequences,
  alarms,
  interlocks,
  faults,
  kpis,
  layout,
  scenarios: [...scenarios, ...tuningChallenges],
  lessons,
  extraTags,
  designPreset,
  warmStartS: 7200,
  trendGroups: [
    { id: 'reactor', name: 'Reactor', tags: ['TT-201.PV', 'TIC-201.SP', 'FT-202.PV', 'TT-202.PV', 'LT-203.PV'] },
    { id: 'heat', name: 'Heat balance', tags: ['R-201.QRXN', 'R-201.QJKT', 'R-201.UA', 'TT-204.PV', 'TT-201.PV'] },
    { id: 'feed', name: 'Feed', tags: ['FT-101.PV', 'FT-102.PV', 'TT-103.PV', 'AT-101.PV'] },
    { id: 'separation', name: 'Separation', tags: ['PT-301.PV', 'LT-302.PV', 'TT-301.PV', 'FT-302.PV'] },
    { id: 'quality', name: 'Quality', tags: ['AT-201.PV', 'R-201.CONV', 'AT-401.PV'] },
  ],
};
